module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-result "
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading dash-bg-color-skin-light-10"
  }, [_c('div', {
    staticClass: "col-xs-2 pull-left align-left head-left"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pcDisp),
      expression: "pcDisp"
    }],
    staticClass: "rec"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pcDisp),
      expression: "!pcDisp"
    }],
    staticClass: "fa fa-search cursor-pointer",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.receivedMultiSelect()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 pull-left align-center head-center"
  }, [_c('div', {
    staticClass: "contactlabel"
  }, [_vm._v(" " + _vm._s(_vm.labels[_vm.nowLang].contactLabel) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 pull-right align-right head-right"
  }, [_c('i', {
    staticClass: "fa fa-refresh cursor-pointer",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pcDisp),
      expression: "pcDisp"
    }],
    staticClass: "col-xs-2 pull-right align-right head-right"
  }, [_c('i', {
    staticClass: "fa fa-search cursor-pointer",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.receivedMultiSelect()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body1"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [(_vm.contactsRows.length > 0) ? _vm._l((_vm.contactsRows), function(contact, index) {
    return _c('tr', {
      key: index,
      staticClass: "pc-big-list cursor-pointer",
      on: {
        "click": function($event) {
          _vm.getContact(contact)
        }
      }
    }, [_c('td', {
      staticClass: "pc-big-fav"
    }, [_c('contact-fav', {
      attrs: {
        "postContactFavorite": _vm.postContactFavorite,
        "codempid": contact.codempid
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      },
      model: {
        value: (contact.codempfav),
        callback: function($$v) {
          _vm.$set(contact, "codempfav", $$v)
        },
        expression: "contact.codempfav"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "pc-big-img"
    }, [(contact.image_path !== '') ? [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": _vm.baseURL + contact.image_path
      }
    })] : [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": require("static/images/employee/no_image.png")
      }
    })]], 2), _vm._v(" "), _c('td', {
      staticClass: "pc-big-text"
    }, [_c('div', {
      staticClass: "name dash-color-skin"
    }, [_vm._v(_vm._s(contact.desc_codempid))]), _vm._v(" "), _c('div', {
      staticClass: "company"
    }, [_vm._v(_vm._s(contact.desc_codcomp))]), _vm._v(" "), _c('div', {
      staticClass: "position"
    }, [_vm._v(_vm._s(contact.desc_codpos))])])])
  }) : [_c('tr')], _vm._v(" "), (_vm.triggerContactInfiniteBool) ? _c('hrms-infinite-loading', {
    ref: "contactsLoading",
    on: {
      "infinite": _vm.onInfinite
    }
  }) : _vm._e()], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73593988!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/contactList.vue
// module id = 3868
// module chunks = 1